<div>
    <app-table-component
        [data]="employeeActivitiesList()"
        [columns]="tableColumns"
        [totalRecords]="totalRecords()"
        [rows]="rows"
        [first]="first"
        (pageChange)="onPageChange($event)"
        [showColumnSelector]="false"
        [showClearFilters]="false"
        (searchChange)="onSearchChange()"
        [searchControl]="searchControl"
        (dropdownChange)="onTypeChange($event)"
        [customFilters]="[targetTypeFilter, createdDateFilter]" />
</div>
